@if (showNotification()) {
    <div class="update-notification" [attr.data-testid]="'app-update-dialog'">
        <div class="flex flex-col">
            <div class="text-lg font-semibold mb-2">Nová verze</div>

            <div class="text-justify mb-4">
                Je k dispozici nová verze aplikace. Pro správný chod aplikace prosím aktualizujte.
            </div>

            <div class="flex flex-row gap-4 items-center justify-items-stretch">
                <button
                    (click)="updateNow()"
                    [disabled]="!canUpdate() || isUpdating()"
                    [attr.data-testid]="'app-update-dialog-update'"
                    class="update-btn">
                    {{ isUpdating() ? 'Aktualizace...' : 'Aktualizovat' }}
                </button>
                <button (click)="dismiss()" [attr.data-testid]="'app-update-dialog-dismiss'" class="dismiss-btn">
                    Odložit
                </button>
            </div>
        </div>
    </div>
}
